
import CardImage from "../../../../Atoms/CardImage";
import './styles.css';

import calendarImg from '../../../../../assets/img/project-covers/calendar.png';
import cardProjectImg from '../../../../../assets/img/project-covers/card_project.png';
import chatsImg from '../../../../../assets/img/project-covers/chats.png';
import dashboardImg from '../../../../../assets/img/project-covers/dashboard.png';
import flyImg from '../../../../../assets/img/project-covers/fly.png';
import ideaImg from '../../../../../assets/img/project-covers/idea.png';
import meetingImg from '../../../../../assets/img/project-covers/meeting.png';
import stikieNotesImg from '../../../../../assets/img/project-covers/stikieNotes.png';
import talkImg from '../../../../../assets/img/project-covers/talk.png';
import talk2Img from '../../../../../assets/img/project-covers/talk2.png';
import timerImg from '../../../../../assets/img/project-covers/timer.png';
import zoomMeetingImg from '../../../../../assets/img/project-covers/zoom_meeting.png';

const PROJECT_COVERS = [
    calendarImg,
    cardProjectImg,
    chatsImg,
    dashboardImg,
    flyImg,
    ideaImg,
    meetingImg,
    stikieNotesImg,
    talkImg,
    talk2Img,
    timerImg,
    zoomMeetingImg
];

const getImageForIdea = (ideaId) => {
    const index = ideaId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % PROJECT_COVERS.length;
    return PROJECT_COVERS[index];
};

export default function ConceptCard({ 
    id,
    title,
    ideaId,
    className = "",
    onClick,
    conceptImageUrl
}) {
    const imageSrc = conceptImageUrl || getImageForIdea(ideaId || id);

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <div 
            className={`concept-card ${className}`}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
        >
            <div className="concept-card-image-wrapper">
                <CardImage 
                    src={imageSrc} 
                    alt={title || 'Concept card'} 
                />
                <div className="concept-card-overlay">
                    <div className="concept-card-content">
                        <h4 className="concept-card-title">{title}</h4>
                    </div>
                </div>
            </div>
        </div>
    );
}

